import Logo from '../static/images/dashboard/seller_logo.png';
import TrustedBatch from '../static/images/dashboard/trusted_seller.png';
import AssetSample from '../static/images/dashboard/digital_asset_img.png';
import AssetSam1 from '../static/images/dashboard/sam1.png';
import AssetSam2 from '../static/images/dashboard/sam2.png';
import AssetSam3 from '../static/images/dashboard/sam3.png';
import publicImg from '../static/images/dashboard/public_icon.png';
import privateImg from '../static/images/dashboard/private_icon.png';
import dollarBatch from '../static/images/dashboard/applied_paid_promo_batch.png';
import trashImg from '../static/images/dashboard/delete_icon.png';
import ArrowNext from '../static/images/dashboard/arrow-left.png';
import ArrowRight from '../static/images/dashboard/arrow-right.png';
import WhiteShirt from '../static/images/dashboard/white_tshirt.png';
import GreenBatch from '../static/images/dashboard/green_batch.png';
import AlertIcon from '../static/images/dashboard/alert_icon.png';
import AwardBadge from '../static/images/dashboard/AwardBadge.png'
import VerifiedIcon from '../static/images/dashboard/verified_tick.png'
import NoContentImg from '../static/images/dashboard/no-content-img.svg'
import verifiedUser from '../static/images/dashboard/verifiedUser.png'


const DashboardImgs = {
  verifiedUser,
  NoContentImg,
  VerifiedIcon,
  Logo,
  TrustedBatch,
  AssetSample,
  publicImg,
  privateImg,
  dollarBatch,
  trashImg,
  AssetSam1,
  AssetSam2,
  AssetSam3,
  ArrowNext,
  ArrowRight,
  WhiteShirt,
  GreenBatch,
  AlertIcon,
  AwardBadge
};

export default DashboardImgs;